//@flow
import isISO8601 from 'validator/lib/isISO8601';
import GlobalData from '../globalData';

const RESIZE_PATH = GlobalData.get('imagePath') || '/resize';
/*
  constructor(attributes): new Model(attributes)
    saves the attributes in the `attributes` property.

  get(attributeKey): it return the value of the atrribute.
*/
export default class Model<T: { [key:string]:any }> {
  attributes:$Shape<T>;

  constructor(attributes:?$Shape<T>) {
    this.attributes = attributes || {};
  }

  get(attribute:$Keys<T>) {
    return this.attributes[attribute];
  }

  _set(key:string, value:any) {
    if (key) {
      this.attributes[key] = value;
    }
  }

  _getFloat(valString:?string|number):?number {
    const val = parseFloat(valString);
    return isNaN(val) ? undefined : val;
  }

  _getDate(date:?string):?Date {
    return date && isISO8601(date) ? new Date(date) : undefined;
  }

  _getResizeUrl(width:number, height:number):string {
    const adjWidth = (parseInt(width) * _devicePixelRatio()).toString();
    const adjHeight = (parseInt(height) * _devicePixelRatio()).toString();
    return `${RESIZE_PATH}/${adjWidth}/${adjHeight}/crop/h/media/catalog`;
  }

  isLoaded() {
    return Object.keys(this.attributes).length !== 0;
  }
}

function _devicePixelRatio():number {
  if (!window) return 1;
  if (window.devicePixelRatio > 2) return 3;
  if (window.devicePixelRatio > 1) return 2;
  return 1;
}
